var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CardShell',[_c('MenuItem',{staticClass:"ph3 h3",attrs:{"image":require("@/assets/img/icon_invoices.svg"),"title":"Invoices","route":"/invoices","childRoutes":['/invoice-detail']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }